import React from 'react';
import { SolutionDetailTemplate } from '../shared/SolutionDetailTemplate';

export const AIPoweredDecisionMakingPage: React.FC = () => {
  return (
    <SolutionDetailTemplate
      title="AI-Powered Decision Making"
      description="We make data clear, accessible, and actionable—turning massive datasets into strategic insights for informed business decisions."
      category="Intelligent Analytics"
      categoryColor="#0FFFA0"
      keyFeatures={[
        "NLP-powered summarization & sentiment analysis",
        "Automated classification, trend detection, and behavior insights",
        "AI-driven recommendations aligned with business goals",
        "Advanced data visualization and reporting",
        "Predictive analytics and forecasting",
        "Real-time decision support systems"
      ]}
      benefits={[
        "Transform complex data into actionable insights",
        "Reduce decision-making time by up to 60%",
        "Improve accuracy of business predictions",
        "Enable data-driven strategic planning",
        "Automate routine analysis tasks",
        "Enhance competitive advantage through insights",
        "Support faster response to market changes"
      ]}
      useCases={[
        "Customer behavior analysis and segmentation",
        "Market trend analysis and forecasting",
        "Financial risk assessment and modeling",
        "Content analysis and summarization",
        "Recommendation systems for products/services",
        "Business intelligence and reporting automation",
        "Strategic planning and scenario analysis",
        "Performance optimization and benchmarking"
      ]}
      relatedTools={[
        {
          name: "Panaceon",
          description: "ML‑assisted code suggestions with confidence and denial‑risk checks.",
          href: "/products/ai/Panaceon"
        },
        {
          name: "Predictive Maintenance ",
          description: "Remaining‑useful‑life predictions and failure risk scoring.",
          href: "/products/ai/predictivemaintenance"
        },
        {
          name: "MVS x AI",
          description: "CV‑based recognition to classify PPE status in real time.",
          href: "/products/ai/mvsxAi"
        },
        {
          name: "Asset Management",
          description: "Anomaly detection and risk scoring across assets locations.",
          href: "/products/ai/assetmanagement"
        },
        {
          name: "Tawjih.AI ",
          description: "Next best action, credit risk scores, and customer guidance.",
          href: "/products/ai/tawjihai"
        },
        {
          name: "Geneseque",
          description: "Interprets genomic data for variant prioritization and clinical insights.",
          href: "/products/ai/geneseqer"
        },
        {
          name: "AI Cooler ",
          description: "Demand/load forecasting to optimize cooling cycles.",
          href: "/products/ai/aicooler"
        },
        {
          name: "Style Sync ",
          description: "Outfit/recommendation engine using preference and context signals.",
          href: "/products/style-sync"
        },
        {
          name: "Finance Policy Check",
          description: "Cash‑flow forecasting and anomaly detection on ledger data.",
          href: "/products/ai/financepolicycheck"
        }
      ]}
      industries={[
        "Banking & Financial Services",
        "Retail & E-commerce",
        "Healthcare & Life Sciences",
        "Technology & IT Services",
        "Education & Research"
      ]}
    />
  );
};